import {
  DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION,
  DataRoomNdaSigningTimelineAction,
} from 'router/subrouters/DataRoom/models/DataRoomNDA';

export const NDA_SIGNING_TRACK_EVENTS_COPY: Record<
  DataRoomNdaSigningTimelineAction,
  string
> = {
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.SENT]: 'NDAsentToUser',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.SIGNED]: 'userSignedNDA',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.REMINDER]: 'NDAreminderSentToUser',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.REJECTED]: 'userRejectedNDA',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.COUNTER_SENT]: 'NDAsentToUser',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.COUNTER_SIGNED]: 'userSignedNDA',
};
